require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-leons-smash-burgers-pop-up.json") })
        }
      }, "path---news-leons-smash-burgers-pop-up");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-leons-smash-burgers-pop-up!./.cache/json/news-leons-smash-burgers-pop-up.json
// module id = 826
// module chunks = 231608221292675